(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nicole-rescue"] && !Shopify.designMode) return;
  try {
    

(() => {
  window.nicoleCartListeners?.abort();
  const controller = new AbortController();
  window.nicoleCartListeners = controller;
  const options = {capture:true,signal:controller.signal};

  window.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nc-activate]');
    if (!button) return;
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy','true');
    let status = button.nextElementSibling;
    if (!status?.matches('[data-nc-code-status]')) {
      status = document.createElement('p');
      status.className = 'nc-small';
      status.dataset.ncCodeStatus = '';
      status.setAttribute('role','status');
      button.after(status);
    }
    status.textContent = 'Applying your code…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const destination = root + 'cart.js';
      const response = await fetch(root + 'discount/' + encodeURIComponent(button.dataset.code) + '?redirect=' + encodeURIComponent(destination),{credentials:'same-origin',redirect:'follow',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Code activation unavailable');
      await response.json();
      status.textContent = 'Code activated. Your eligible discount will be shown at checkout.';
    } catch (_) {
      status.textContent = '';
      const fallback = document.createElement('a');
      fallback.href = button.dataset.storeLink;
      fallback.target = '_blank';
      fallback.rel = 'noopener';
      fallback.textContent = 'Activate code in the store';
      status.append(fallback);
    } finally { button.removeAttribute('aria-busy'); }
  }, options);
  window.addEventListener('change', (event) => {
    const select = event.target.closest('[data-nc-variant]');
    if (!select) return;
    const card = select.closest('[data-nc-product]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    card.querySelector('[data-nc-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-nc-compare]');
    const badge = card.querySelector('[data-nc-discount]');
    const discount = Number(option.dataset.discount || 0);
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    badge.textContent = '−' + discount + '%';
    badge.hidden = discount <= 0;
    for (const link of card.querySelectorAll('[data-nc-shop-now],[data-nc-main-link]')) link.href = option.dataset.url;
  }, options);
  const add = (form) => {
    if (!form || form.dataset.pending === 'true') return;
    const button = form.querySelector('.nc-add-button');
    if (!button || button.disabled) return;
    const status = form.querySelector('[data-nc-cart-status]');
    const data = new FormData(form);
    const root = window.Shopify?.routes?.root || '/';
    form.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    status.removeAttribute('data-error');
    status.textContent = form.dataset.adding || 'Adding to cart…';
    const perform = async () => {
      let added = false;
      try {
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
        if (sections.length) { data.set('sections',sections.join(',')); data.set('sections_url',window.location.pathname); }
        const response = await fetch(root+'cart/add.js',{method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || form.dataset.failed || 'Could not add this item.');
        added = true;
        status.textContent = form.dataset.added || 'Added to cart.';
        const countResponse = await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
        if (!countResponse.ok) throw new Error('Count refresh failed');
        const cart = await countResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:form.id,data:{source:'nicole-rescue',itemCount:cart.item_count,sections:result.sections || {},variantId:String(data.get('id'))}}}));
      } catch (error) {
        if (added) status.textContent = form.dataset.countPending || 'Added to cart. Open your cart to see the latest total.';
        else { status.setAttribute('data-error',''); status.textContent = error.message || form.dataset.failed; }
      } finally {
        delete form.dataset.pending;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };
    window.nicoleCartQueue = (window.nicoleCartQueue || Promise.resolve()).catch(()=>{}).then(perform);
  };
  window.addEventListener('click', (event) => {
    const button = event.target.closest('.nc-cart-form .nc-add-button');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(button.closest('.nc-cart-form'));
  }, options);
  window.addEventListener('submit', (event) => {
    const form = event.target.closest('.nc-cart-form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(form);
  }, options);
})();


(() => {
  const animateDonation = (root) => {
    for (const number of root.querySelectorAll('[data-nc-donation-count]')) {
      if (number.dataset.animated === 'true') continue;
      number.dataset.animated = 'true';
      const target = Math.max(0,Math.floor(Number(number.dataset.count) || 0));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {number.textContent = String(target);continue;}
      number.textContent = '0';
      let started;
      const step = (time) => {
        if (!number.isConnected) return;
        started ??= time;
        const progress = Math.min(1,(time-started)/1200);
        number.textContent = String(Math.floor(target*(1-Math.pow(1-progress,3))));
        if (progress < 1) requestAnimationFrame(step);
        else number.textContent = String(target);
      };
      requestAnimationFrame(step);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>animateDonation(document),{once:true});
  else animateDonation(document);
  document.addEventListener('shopify:section:load',event=>animateDonation(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
